// JOH World — LEVEL 2: PUSH-UP CHALLENGE (binnen in de JOH Gym; géén platforming).
import { PAL, VW, Particles, FloatTexts, pixelText } from "./engine";
import { drawGym } from "./gym";
import { drawFighter } from "./sprites";
import { sfx } from "./audio";

const DURATION = 15.0;
const TARGET = 50;
const FLOOR_Y = 178;

// donkere band achter tekst voor leesbaarheid op de drukke gymwand
function textBand(ctx, y, h) {
  ctx.fillStyle = "rgba(10,10,10,0.62)";
  ctx.fillRect(40, y, VW - 80, h);
}

export class Level2 {
  // cb: onScore(n), onPass(pushups)
  constructor(cb) {
    this.cb = cb;
    this.t = 0;
    this.phase = "enter"; // enter → late → coach → play → result
    this.phaseT = 0;
    this.playerX = -30;
    this.pushups = 0;
    this.timeLeft = DURATION;
    this.pose = "pushupUp";
    this.result = null; // "pass" | "fail"
    this.particles = new Particles();
    this.texts = new FloatTexts();
  }

  press() {
    if (this.phase !== "play") return false;
    this.pushups += 1;
    this.pose = this.pose === "pushupUp" ? "pushupDown" : "pushupUp";
    this.cb.onScore?.(5);
    sfx.pushup();
    this.particles.burst(this.playerX, FLOOR_Y + 2, PAL.beige, 3, 24, 0.3, 1);
    return true;
  }

  update(dt) {
    this.t += dt;
    this.phaseT += dt;
    this.particles.update(dt);
    this.texts.update(dt);

    if (this.phase === "enter") {
      this.playerX = Math.min(150, this.playerX + 80 * dt);
      if (this.playerX >= 150 && this.phaseT > 1.2) this._to("late");
    } else if (this.phase === "late" && this.phaseT > 1.7) {
      this._to("coach");
    } else if (this.phase === "coach" && this.phaseT > 1.5) {
      this._to("play");
      sfx.start();
    } else if (this.phase === "play") {
      this.timeLeft -= dt;
      if (this.timeLeft <= 0) {
        this.timeLeft = 0;
        this.result = this.pushups >= TARGET ? "pass" : "fail";
        this._to("result");
        if (this.result === "pass") {
          this.cb.onScore?.(100);
          sfx.pushupPass();
        } else {
          sfx.pushupFail();
        }
      }
    }
  }

  _to(phase) { this.phase = phase; this.phaseT = 0; }

  retry() {
    this.pushups = 0;
    this.timeLeft = DURATION;
    this.result = null;
    this.pose = "pushupUp";
    this._to("coach");
  }

  // parent roept dit aan bij TRY AGAIN of na PASS-continue
  get passed() { return this.result === "pass"; }

  finishPass() { this.cb.onPass?.(this.pushups); }

  draw(ctx) {
    drawGym(ctx, this.t, "floor");

    // speler
    if (this.phase === "enter" || this.phase === "late") {
      drawFighter(ctx, this.playerX, FLOOR_Y, 34, this.phase === "enter" ? "walk" : "idle", this.t);
    } else if (this.phase === "play" || (this.phase === "result" && this.result === "fail")) {
      drawFighter(ctx, this.playerX, FLOOR_Y - 6, 40, this.pose, this.t);
    } else {
      drawFighter(ctx, this.playerX, FLOOR_Y, 34, this.result === "pass" ? "victory" : "idle", this.t);
    }

    this.particles.draw(ctx);
    this.texts.draw(ctx);

    // teksten
    if (this.phase === "late") {
      textBand(ctx, 34, 20);
      pixelText(ctx, "OH NO... YOU'RE LATE!", VW / 2, 40, 11, PAL.red, "center");
    } else if (this.phase === "coach") {
      textBand(ctx, 28, 44);
      pixelText(ctx, "COACH: 15 SECONDS.", VW / 2, 36, 9, PAL.cream, "center");
      pixelText(ctx, "50 PUSH-UPS. GO!", VW / 2, 52, 9, PAL.yellow, "center");
    } else if (this.phase === "play") {
      const urgent = this.timeLeft <= 3;
      textBand(ctx, 16, 52);
      pixelText(ctx, `${this.timeLeft.toFixed(1)} SEC`, VW / 2, 24, 12, urgent && Math.floor(this.t * 6) % 2 === 0 ? PAL.red : PAL.cream, "center");
      pixelText(ctx, `PUSH-UPS: ${this.pushups}`, VW / 2, 44, 10, this.pushups >= TARGET ? PAL.yellow : PAL.cream, "center");
      pixelText(ctx, `DOEL: ${TARGET}`, VW / 2, 60, 6, PAL.greyLight, "center");
    } else if (this.phase === "result") {
      textBand(ctx, 26, 76);
      if (this.result === "pass") {
        pixelText(ctx, "PASSED!", VW / 2, 34, 14, PAL.yellow, "center");
        pixelText(ctx, `YOU DID ${this.pushups} PUSH-UPS!`, VW / 2, 58, 8, PAL.cream, "center");
        if (this.phaseT > 1.6) pixelText(ctx, "COACH: ALRIGHT...", VW / 2, 78, 7, PAL.cream, "center");
        if (this.phaseT > 2.6) pixelText(ctx, "LET'S SEE THOSE HANDS.", VW / 2, 92, 7, PAL.yellow, "center");
      } else {
        pixelText(ctx, "NOT ENOUGH!", VW / 2, 34, 13, PAL.red, "center");
        pixelText(ctx, `YOU DID ${this.pushups}. YOU NEED AT LEAST ${TARGET}.`, VW / 2, 58, 7, PAL.cream, "center");
      }
    }
  }
}
